import { FC, useState } from "react";
import { useAppDispatch, useAppSelector } from "@/shared/lib/redux";
import { fetchEnableWhitelist, fetchDisableWhitelist, fetchWhitelistedPhones } from "../../model";
import { selectCommunityLoading, selectCommunityInfo } from "@/entities/community";
import notify from "@/shared/lib/notify";
import { getErrorMessage } from "@/shared/consts/error-codes";
import { Loader } from "@/shared/ui/loader";

export const WhitelistToggle: FC = () => {
    const dispatch = useAppDispatch()
    const communityInfo = useAppSelector(selectCommunityInfo)
    const isLoading = useAppSelector(selectCommunityLoading)
    const [isToggling, setIsToggling] = useState(false)

    const handleToggle = async (checked: boolean) => {
        setIsToggling(true)
        try {
            if (checked) {
                await dispatch(fetchEnableWhitelist()).unwrap()
                notify.success('Белый список телефонов включен')
            } else {
                await dispatch(fetchDisableWhitelist()).unwrap()
                notify.success('Белый список телефонов выключен')
            }
            dispatch(fetchWhitelistedPhones())
        } catch (error: any) {
            notify.error(getErrorMessage(error))
        } finally {
            setIsToggling(false)
        }
    };

    return (
        <div className="box">
            <div className="box_header !mb-4 font-mediumttf">
                Настройки белого списка
            </div>
            <div className="flex flex-col gap-4">
                <div className="text-[13px] font-semibold text-color-secondary">
                    Когда белый список включен, регистрация разрешена только для телефонов из списка.
                    Когда выключен, регистрация доступна для всех телефонов.
                </div>
                {!isLoading ? (
                    <div className="flex items-center gap-4">
                        <div className="flex flex-col w-full gap-[6px] pb-[8px] border-b-[1.5px] border-[#B9C9C6]">
                            <label className="font-semibold uppercase text-base text-[#828282]">
                                Включить белый список
                            </label>
                            <input
                                className="relative w-[3.25rem] h-7 bg-[#B9C9C6] checked:bg-none checked:bg-color-primary border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 ring-0 ring-transparent focus:ring-transparent ring-offset-white focus:outline-0 appearance-none dark:bg-black/20 dark:checked:bg-primary dark:focus:ring-offset-white/10 before:inline-block before:w-6 before:h-6 before:bg-white checked:before:bg-white before:translate-x-0 checked:before:translate-x-full before:shadow before:rounded-full before:transform before:ring-0 before:transition before:ease-in-out before:duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
                                type="checkbox"
                                checked={communityInfo.is_whitelist_enabled}
                                disabled={isToggling}
                                onChange={(e) => handleToggle(e.target.checked)}
                            />
                        </div>
                    </div>
                ) : (
                    <Loader />
                )}
            </div>
        </div>
    );
};

